import styled from 'styled-components'

import { Link as LinkBase } from '@application/Interfaces/Atoms/Link'
import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Accordion as AccordionBase } from '@icontainers/design-system/dist/organisms/Accordion'

export const Title = styled.h2`
    ${(props) => props.theme.typo.displayL};
    ${(props) => props.theme.fontWeight.regular};
`

export const Description = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    line-height: 180%;
    margin-top: 10px;
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    margin-top: 30px;
    text-transform: uppercase;
    text-decoration: none;
    display: inline-block;

    svg {
        margin-left: 8px;
    }
`

export const Accordion = styled(AccordionBase)`
    background-color: ${(props) => props.theme.color.white};

    .description-accordion-title {
        ${(props) => props.theme.fontWeight.medium};
    }
`

export const AccordionDescription = styled.div`
    ${(props) => props.theme.typo.bodyS};
    color: ${(props) => props.theme.color.g600};
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    padding: 50px 20px;
    background-color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.p600 : props.theme.color.g100)};

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 100px 0;
    }

    ${Title}, ${Link} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.p500)};
    }

    ${Description} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.g600)};
    }

    ${Link} {
        &:hover,
        &:focus,
        &:active {
            color: ${(props) => props.theme.color.a500};

            svg path {
                fill: ${(props) => props.theme.color.a500};
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }
`
